import * as z from 'zod';

import { inventoryQueryLinkerSchema } from '@/_pages/settings/inventory-kits/shared/schemas/inventory';
import { inventoryKitItemQuerySchema } from '@/_pages/settings/inventory-kits/shared/schemas/inventory-kit-item';

export const pickTicketsItemQuerySchema = inventoryKitItemQuerySchema
  .omit({ inventory_kit_id: true, inventory: true })
  .extend({
    pick_ticket_id: z.number(),
    inventory: inventoryQueryLinkerSchema.nullish(),
  });

export type PickTicketsItemQuerySchema = z.infer<typeof pickTicketsItemQuerySchema>;
